// src/locales/manage-p2-vi.ts
export default {
  management: {
    rights: {
      title: "Quản lý bản quyền",
      description: "Quản lý và bảo vệ tác phẩm của bạn",
      tabs: {
        works: "Tác phẩm",
        licenses: "Giấy phép",
        violations: "Vi phạm",
        revenue: "Doanh thu",
        contracts: "Hợp đồng",
        settings: "Cài đặt"
      }
    },
    works: {
      title: "Tác phẩm của tôi",
      registerNew: "Đăng ký tác phẩm mới",
      emptyState: {
        title: "Chưa có tác phẩm nào",
        description: "Bạn chưa đăng ký tác phẩm nào. Hãy bắt đầu đăng ký tác phẩm đầu tiên của bạn."
      },
      filters: {
        all: "Tất cả loại",
        image: "Hình ảnh",
        audio: "Âm thanh",
        video: "Video",
        text: "Văn bản",
        other: "Khác",
        status: {
          all: "Tất cả trạng thái",
          approved: "Đã duyệt",
          pending: "Chờ duyệt",
          rejected: "Từ chối",
          draft: "Bản nháp"
        }
      },
      search: "Tìm kiếm tác phẩm...",
      noResults: "Không tìm thấy tác phẩm",
      noResultsDesc: "Không có tác phẩm nào phù hợp với bộ lọc hiện tại.",
      loading: "Đang tải dữ liệu...",
      status: {
        approved: "Đã duyệt",
        pending: "Chờ duyệt",
        rejected: "Từ chối",
        draft: "Bản nháp"
      },
      protection: {
        score: "Điểm bảo vệ",
        high: "Cao",
        medium: "Trung bình",
        low: "Thấp"
      },
      actions: {
        view: "Xem chi tiết",
        edit: "Chỉnh sửa",
        delete: "Xóa",
        protect: "Tăng bảo vệ",
        license: "Cấp phép"
      },
      metadata: {
        title: "Cập nhật metadata",
        subtitle: "Chỉnh sửa thông tin mô tả cho tác phẩm",
        notFound: "Không tìm thấy dữ liệu",
        sections: {
          basicInfo: "Thông tin cơ bản",
          workInfo: "Thông tin tác phẩm",
          classification: "Phân loại và từ khóa",
          additionalInfo: "Thông tin bổ sung",
          timeInfo: "Thông tin thời gian",
          versionHistory: "Lịch sử phiên bản",
          changeDescription: "Mô tả thay đổi",
        },
        fields: {
          title: "Tiêu đề",
          titlePlaceholder: "Nhập tiêu đề tác phẩm",
          titleHelp: "Tiêu đề rõ ràng giúp dễ dàng tìm kiếm và nhận diện tác phẩm",
          description: "Mô tả",
          descriptionPlaceholder: "Mô tả chi tiết về nội dung và mục đích của tác phẩm",
          descriptionHelp: "Mô tả chi tiết giúp người dùng hiểu rõ về tác phẩm của bạn",
          contentKind: "Loại nội dung",
          contentRating: "Xếp hạng nội dung",
          category: "Danh mục",
          industry: "Ngành nghề",
          tags: "Từ khóa",
          tagsPlaceholder: "Thêm từ khóa và nhấn Enter",
          tagsHelp: "Thêm từ khóa giúp tác phẩm dễ dàng được tìm thấy",
          language: "Ngôn ngữ",
          status: "Trạng thái",
          statusHelp: "Trạng thái chỉ có thể thay đổi trong quy trình phê duyệt",
          creationDate: "Ngày sáng tạo",
          registrationDate: "Ngày đăng ký",
          registrationDateHelp: "Ngày đăng ký không thể thay đổi",
          changeLog: "Mô tả thay đổi",
          changeLogPlaceholder: "Mô tả ngắn gọn về các thay đổi bạn vừa thực hiện",
          changeLogHelp: "Thông tin này sẽ được lưu vào lịch sử phiên bản"
        },
        buttons: {
          cancel: "Hủy thay đổi",
          save: "Lưu thay đổi",
          saving: "Đang lưu..."
        },
        messages: {
          success: "Cập nhật metadata thành công!",
          error: "Không thể cập nhật metadata. Vui lòng thử lại sau.",
          confirmCancel: "Bạn có chắc muốn hủy các thay đổi?"
        }
      },
      register: {
        title: "Đăng ký tác phẩm mới",
        steps: {
          upload: "Tải lên",
          info: "Thông tin",
          distribution: "Phân phối",
          protection: "Bảo vệ",
          confirm: "Xác nhận"
        },
        fields: {
          contentKind: "Loại tác phẩm",
          uploadTitle: "Tải lên tác phẩm",
          uploadDescription: "Kéo và thả các tệp vào đây hoặc nhấp để duyệt",
          uploadFormats: "Hỗ trợ: JPEG, PNG, GIF, MP3, MP4, PDF, DOC, TXT (tối đa 100MB)",
          uploadButton: "Chọn tệp",
          selectedFiles: "Đã chọn {count} tệp:",
          title: "Tiêu đề tác phẩm",
          description: "Mô tả",
          descriptionPlaceholder: "Mô tả chi tiết về tác phẩm",
          category: "Danh mục",
          selectCategory: "Chọn danh mục",
          tags: "Từ khóa (Tags)",
          isPublic: "Hiển thị trong danh mục công khai",
          isPublicHelp: "Nếu được chọn, tác phẩm của bạn sẽ hiển thị trong danh mục công khai và có thể được tìm kiếm bởi người mua tiềm năng",
          collaborators: "Người đóng góp",
          collaboratorsEmpty: "Không có người đóng góp nào được thêm vào.",
          collaboratorsHelp: "Bạn sẽ được liệt kê là người sáng tạo duy nhất với 100% quyền sở hữu.",
          addCollaborator: "Thêm người đóng góp",
          collaboratorName: "Tên",
          collaboratorEmail: "Email",
          collaboratorShare: "Tỷ lệ phân phối (%)",
          totalDistribution: "Tổng tỷ lệ phân phối:",
          totalDistributionError: "Tổng tỷ lệ phân phối phải bằng 100%.",
          protection: {
            title: "Biện pháp bảo vệ",
            description: "Chọn biện pháp bảo vệ cho tác phẩm của bạn. Các biện pháp bảo vệ giúp ngăn chặn sử dụng trái phép và tăng cường khả năng bảo vệ quyền sở hữu.",
            watermark: "Watermark tự động",
            watermarkDesc: "Thêm watermark kỹ thuật số vào tác phẩm của bạn để ngăn chặn sao chép trái phép.",
            aiMonitoring: "AI Monitoring",
            aiMonitoringDesc: "Sử dụng AI để quét và phát hiện vi phạm bản quyền trên các nền tảng trực tuyến.",
            blockchain: "Chứng nhận Blockchain",
            blockchainDesc: "Đăng ký tác phẩm của bạn trên blockchain để xác minh quyền sở hữu và tính xác thực.",
            score: "Điểm bảo vệ ước tính",
            scoreHelp: "Điểm bảo vệ cho biết mức độ bảo vệ tác phẩm của bạn. Điểm cao hơn có nghĩa là tác phẩm được bảo vệ tốt hơn."
          },
          confirmation: {
            title: "Tất cả thông tin đã sẵn sàng!",
            description: "Vui lòng xem lại thông tin tác phẩm của bạn và nhấn \"Đăng ký\" để hoàn tất.",
            workInfo: "Thông tin tác phẩm",
            collaboratorInfo: "Người đóng góp",
            protectionInfo: "Biện pháp bảo vệ",
            terms: "Tôi đồng ý với Điều khoản và Điều kiện sử dụng",
            ownership: "Tôi xác nhận rằng tôi có quyền đăng ký bản quyền cho tác phẩm này",
            on: "Bật",
            off: "Tắt"
          }
        },
        buttons: {
          back: "Quay lại",
          continue: "Tiếp tục",
          register: "Đăng ký tác phẩm",
          processing: "Đang xử lý..."
        },
        success: {
          title: "Đăng ký thành công!",
          description: "Tác phẩm của bạn đã được đăng ký thành công và đang chờ xét duyệt.",
          viewAll: "Xem danh sách tác phẩm",
          registerAnother: "Đăng ký tác phẩm khác"
        }
      },
      details: {
        title: "Chi tiết tác phẩm",
        backToList: "Quay lại danh sách",
        loading: "Đang tải thông tin tác phẩm...",
        error: "Không tìm thấy tác phẩm với ID: {id}",
        actions: {
          edit: "Chỉnh sửa",
          download: "Tải xuống",
          share: "Chia sẻ",
          report: "Báo cáo vi phạm"
        },
        info: {
          title: "Thông tin tác phẩm",
          registrationDate: "Ngày đăng ký",
          owner: "Chủ sở hữu",
          views: "Lượt xem",
          licenses: "Giấy phép",
          protectionScore: "Điểm bảo vệ"
        },
        tabs: {
          licenses: "Giấy phép",
          violations: "Vi phạm",
          revenue: "Doanh thu"
        },
        licenses: {
          empty: "Chưa có giấy phép nào được cấp cho tác phẩm này.",
          table: {
            id: "ID",
            licensee: "Người được cấp phép",
            type: "Loại",
            startDate: "Ngày bắt đầu",
            endDate: "Ngày kết thúc",
            status: "Trạng thái"
          },
          status: {
            active: "Đang hoạt động",
            expired: "Hết hạn"
          }
        },
        violations: {
          empty: "Không phát hiện vi phạm nào đối với tác phẩm này.",
          table: {
            id: "ID",
            platform: "Nền tảng",
            detectedDate: "Ngày phát hiện",
            status: "Trạng thái",
            actions: "Hành động"
          },
          status: {
            resolved: "Đã giải quyết",
            pending: "Đang xử lý"
          },
          actions: {
            details: "Chi tiết"
          }
        },
        revenue: {
          empty: "Chưa có dữ liệu doanh thu cho tác phẩm này.",
          chart: "Biểu đồ doanh thu",
          table: {
            month: "Tháng",
            revenue: "Doanh thu"
          }
        },
        protection: {
          title: "Trạng thái bảo vệ",
          overall: "Điểm bảo vệ tổng thể",
          features: {
            content: {
              title: "Bảo vệ nội dung",
              description: "Watermark, định danh"
            },
            monitoring: {
              title: "Giám sát vi phạm",
              description: "Quét AI tự động"
            },
            blockchain: {
              title: "Chứng nhận blockchain",
              description: "Xác minh nguồn gốc"
            }
          },
          status: {
            active: "Hoạt động",
            inactive: "Không hoạt động"
          },
          enhance: "Tăng cường bảo vệ"
        },
        relatedWorks: {
          title: "Tác phẩm liên quan"
        }
      }
    },
    licenses: {
      title: "Quản lý giấy phép",
      description: "Quản lý giấy phép sử dụng tác phẩm của bạn",
      create: "Tạo giấy phép mới",
      table: {
        id: "Mã giấy phép",
        work: "Tác phẩm",
        licensee: "Người được cấp phép",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        remainingDays: "Thời hạn còn lại",
        value: "Giá trị",
        status: "Trạng thái",
        actions: "Thao tác"
      },
      status: {
        active: "Đang hoạt động",
        pending: "Chờ phê duyệt",
        completed: "Hoàn thành",
        cancelled: "Đã hủy"
      },
      actions: {
        view: "Xem chi tiết",
        download: "Tải giấy phép",
        renew: "Gia hạn"
      },
      summary: {
        title: "Tổng hợp giấy phép",
        total: "Tổng số giấy phép:",
        active: "Đang hoạt động:",
        pending: "Chờ phê duyệt:",
        completed: "Đã hoàn thành:"
      },
      expiring: {
        title: "Sắp hết hạn",
        empty: "Không có giấy phép nào sắp hết hạn",
        days: "Còn {days} ngày"
      },
      value: {
        title: "Giá trị giấy phép",
        total: "Tổng giá trị:",
        active: "Giấy phép đang hoạt động:",
        completed: "Giấy phép hoàn thành:"
      },
      filters: {
        search: "Tìm kiếm theo tên tác phẩm, tác giả...",
        status: "Trạng thái"
      }
    },
    contracts: {
      title: "Quản lý hợp đồng",
      description: "Xem và quản lý các hợp đồng cấp phép bản quyền",
      search: "Tìm kiếm theo tên tác phẩm, tác giả...",
      filters: "Lọc",
      export: "Xuất",
      loading: "Đang tải dữ liệu...",
      empty: "Không tìm thấy hợp đồng nào",
      table: {
        id: "Mã hợp đồng",
        work: "Tác phẩm",
        owner: "Chủ sở hữu",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        remainingDays: "Thời hạn còn lại",
        value: "Giá trị",
        status: "Trạng thái",
        actions: "Thao tác"
      },
      status: {
        active: "Đang hoạt động",
        pendingApproval: "Chờ phê duyệt",
        completed: "Hoàn thành",
        cancelled: "Đã hủy"
      },
      actions: {
        view: "Xem chi tiết",
        download: "Tải hợp đồng",
        renew: "Gia hạn"
      },
      summary: {
        title: "Tổng hợp hợp đồng",
        total: "Tổng số hợp đồng:",
        active: "Đang hoạt động:",
        pending: "Chờ phê duyệt:",
        completed: "Đã hoàn thành:"
      },
      expiring: {
        title: "Sắp hết hạn",
        empty: "Không có hợp đồng nào sắp hết hạn",
        days: "Còn {days} ngày"
      },
      value: {
        title: "Giá trị hợp đồng",
        total: "Tổng giá trị:",
        active: "Hợp đồng đang hoạt động:",
        completed: "Hợp đồng hoàn thành:"
      }
    },
    violations: {
      title: "Cảnh Báo Vi Phạm",
      description: "Quản lý và gửi cảnh báo đến các bên vi phạm bản quyền",
      create: "Tạo cảnh báo mới",
      search: "Tìm kiếm theo tiêu đề hoặc URL...",
      filters: {
        status: {
          all: "Tất cả trạng thái",
          pending: "Chờ gửi",
          sent: "Đã gửi",
          acknowledged: "Đã phản hồi",
          ignored: "Bị bỏ qua"
        }
      },
      empty: "Không tìm thấy cảnh báo vi phạm nào.",
      loading: "Đang tải dữ liệu...",
      showing: "Hiển thị {shown} trên {total} cảnh báo",
      table: {
        work: "Tác phẩm",
        platform: "Nền tảng",
        detected: "Phát hiện",
        severity: "Mức độ",
        status: "Trạng thái",
        type: "Loại vi phạm",
        actions: "Hành động"
      },
      severity: {
        critical: "Nghiêm trọng",
        high: "Cao",
        medium: "Trung bình",
        low: "Thấp"
      },
      status: {
        pending: "Chờ gửi",
        sent: "Đã gửi",
        acknowledged: "Đã phản hồi",
        ignored: "Bị bỏ qua"
      },
      types: {
        unauthorized_usage: "Sử dụng trái phép",
        deepfake: "Deepfake",
        impersonation: "Mạo danh tác giả",
        false_information: "Thông tin sai lệch",
        inappropriate_content: "Nội dung không phù hợp",
        other: "Khác"
      },
      actions: {
        view: "Xem",
        send: "Gửi",
        block: "Chặn"
      }
    },
    reportViolation: {
      title: "Báo cáo vi phạm bản quyền",
      description: "Báo cáo các trường hợp sử dụng trái phép tác phẩm của bạn",
      form: {
        workId: {
          label: "Tác phẩm bị vi phạm",
          placeholder: "Chọn tác phẩm"
        },
        violationType: {
          label: "Loại vi phạm",
          placeholder: "Chọn loại vi phạm",
          options: {
            unauthorized_usage: "Sử dụng trái phép",
            impersonation: "Mạo danh tác giả",
            inappropriate_content: "Nội dung không phù hợp",
            false_information: "Thông tin sai lệch",
            other: "Khác"
          }
        },
        violationUrl: {
          label: "URL nơi phát hiện vi phạm",
          placeholder: "https://example.com/violation-page"
        },
        platform: {
          label: "Nền tảng",
          placeholder: "Chọn nền tảng",
          options: {
            facebook: "Facebook",
            instagram: "Instagram",
            youtube: "YouTube",
            tiktok: "TikTok",
            website: "Website",
            other: "Khác"
          }
        },
        description: {
          label: "Mô tả chi tiết vi phạm",
          placeholder: "Mô tả chi tiết về vi phạm, bao gồm cách bạn phát hiện, thời điểm phát hiện, và tác động đến bạn."
        },
        evidence: {
          label: "Bằng chứng vi phạm",
          text: "Kéo thả hình ảnh hoặc tập tin bằng chứng vào đây, hoặc nhấp để chọn từ máy tính",
          help: "Bạn có thể đính kèm ảnh chụp màn hình, video, hoặc các tài liệu khác để chứng minh vi phạm. Tối đa 5 tập tin, mỗi tập tin không quá 10MB."
        },
        declaration: {
          label: "Tôi cam đoan những thông tin cung cấp là chính xác và tôi là chủ sở hữu hợp pháp của tác phẩm này."
        },
        buttons: {
          cancel: "Hủy",
          submit: "Gửi báo cáo",
          submitting: "Đang gửi..."
        }
      },
      steps: {
        title: "Quy trình báo cáo vi phạm",
        submit: "Gửi báo cáo",
        submitDesc: "Người dùng gửi báo cáo vi phạm với thông tin chi tiết",
        review: "Xem xét và đánh giá",
        reviewDesc: "Đội ngũ kiểm duyệt sẽ xem xét và đánh giá báo cáo",
        notify: "Thông báo và yêu cầu gỡ bỏ",
        notifyDesc: "Thông báo cho người vi phạm và yêu cầu gỡ bỏ nội dung",
        process: "Xử lý và cập nhật",
        processDesc: "Xử lý cuối cùng và cập nhật trạng thái báo cáo"
      },
      tips: {
        title: "Hướng dẫn báo cáo vi phạm",
        evidence: {
          title: "Chuẩn bị bằng chứng",
          description: "Thu thập ảnh chụp màn hình, video, hoặc tài liệu chứng minh vi phạm. Bằng chứng rõ ràng giúp quá trình xử lý nhanh chóng hơn."
        },
        url: {
          title: "Cung cấp URL chính xác",
          description: "URL nên dẫn trực tiếp đến nội dung vi phạm. Nếu vi phạm xuất hiện ở nhiều nơi, hãy báo cáo riêng cho từng URL."
        },
        timeline: {
          title: "Thời gian xử lý",
          description: "Thông thường, báo cáo sẽ được xem xét trong vòng 24-48 giờ. Các vụ vi phạm nghiêm trọng sẽ được ưu tiên xử lý."
        }
      },
      messages: {
        success: {
          title: "Báo cáo vi phạm đã được gửi thành công!",
          description: "Chúng tôi đã nhận được báo cáo của bạn và sẽ xem xét trong thời gian sớm nhất. Bạn sẽ nhận được thông báo khi có cập nhật về trạng thái xử lý."
        },
        error: {
          title: "Đã xảy ra lỗi!",
          description: "Không thể gửi báo cáo vi phạm. Vui lòng thử lại sau."
        }
      }
    },
    ViolationDetail: {
      title: "Chi tiết báo cáo vi phạm #{id}",
      backToList: "Quay lại danh sách",
      loading: "Đang tải thông tin báo cáo vi phạm...",
      error: {
        title: "Đã xảy ra lỗi",
        notFound: "Không tìm thấy thông tin báo cáo vi phạm với ID: {id}"
      },
      info: {
        title: "Thông tin vi phạm",
        work: "Tác phẩm bị vi phạm",
        type: "Loại vi phạm",
        url: "URL vi phạm",
        platform: "Nền tảng",
        detected: "Ngày phát hiện",
        description: "Mô tả chi tiết"
      },
      evidence: {
        title: "Bằng chứng đính kèm",
        download: "Tải xuống"
      },
      status: {
        title: "Trạng thái xử lý",
        current: "Trạng thái hiện tại",
        history: "Lịch sử cập nhật",
        nextSteps: "Bước tiếp theo"
      },
      actions: {
        title: "Thao tác",
        update: "Cập nhật báo cáo",
        cancel: "Hủy báo cáo"
      },
      statusValues: {
        pending: "Đang chờ xử lý",
        investigating: "Đang điều tra",
        resolved: "Đã giải quyết",
        rejected: "Đã từ chối"
      }
    },
    revenue: {
      title: "Thống kê doanh thu",
      export: "Xuất báo cáo",
      period: {
        label: "Khoảng thời gian:",
        week: "Tuần này",
        month: "Tháng này",
        quarter: "Quý này",
        year: "Năm nay",
        custom: "Tùy chỉnh",
        from: "Từ ngày",
        to: "Đến ngày",
        current: "Dữ liệu hiện tại:"
      },
      summary: {
        total: "Tổng doanh thu",
        license: "Doanh thu từ giấy phép",
        usage: "Doanh thu từ sử dụng",
        growth: "+{percent}% so với kỳ trước",
        percent: "{percent}% tổng doanh thu"
      },
      tabs: {
        overview: "Tổng quan",
        works: "Doanh thu theo tác phẩm"
      },
      charts: {
        revenue: "Biểu đồ doanh thu",
        revenuePlatform: "Doanh thu theo nền tảng"
      },
      transactions: {
        title: "Lịch sử giao dịch",
        table: {
          id: "ID",
          work: "Tác phẩm",
          licensee: "Người được cấp phép",
          amount: "Số tiền",
          date: "Ngày"
        }
      },
      nextPayment: {
        title: "Thanh toán tiếp theo",
        date: "Ngày thanh toán",
        withdraw: "Rút tiền"
      },
      worksTable: {
        work: "Tác phẩm",
        revenue: "Doanh thu",
        growth: "Tăng trưởng",
        details: "Chi tiết"
      }
    },
    payment: {
      title: "Rút tiền từ bản quyền",
      description: "Quản lý và rút tiền từ doanh thu bản quyền của bạn",
      withdrawForm: {
        title: "Tạo yêu cầu rút tiền",
        amount: {
          label: "Số tiền muốn rút",
          placeholder: "Nhập số tiền",
          available: "Số dư khả dụng:"
        },
        method: {
          label: "Phương thức thanh toán",
          placeholder: "Chọn phương thức thanh toán"
        },
        addMethod: "Thêm mới",
        submit: "Rút tiền"
      },
      summary: {
        title: "Tổng quan tài chính",
        balance: "Số dư khả dụng",
        totalWithdrawn: "Tổng đã rút",
        processTime: "Thời gian xử lý",
        processTimeDesc: "2-5 ngày làm việc tùy theo phương thức thanh toán"
      },
      history: {
        title: "Lịch sử rút tiền",
        viewAll: "Xem tất cả",
        loading: "Đang tải...",
        table: {
          id: "ID",
          date: "Ngày yêu cầu",
          amount: "Số tiền",
          method: "Phương thức",
          status: "Trạng thái"
        },
        status: {
          completed: "Hoàn thành",
          processing: "Đang xử lý"
        }
      },
      addMethod: {
        title: "Thêm phương thức thanh toán mới",
        type: {
          label: "Loại phương thức",
          bank: "Tài khoản ngân hàng",
          ewallet: "Ví điện tử"
        },
        name: {
          label: "Tên hiển thị",
          placeholder: "VD: Ngân hàng VCB cá nhân"
        },
        bankName: {
          label: "Tên ngân hàng",
          placeholder: "VD: Vietcombank"
        },
        accountNumber: {
          label: "Số tài khoản",
          ewalletLabel: "Số điện thoại/Email"
        },
        holderName: {
          label: "Tên chủ tài khoản"
        },
        cancel: "Hủy",
        add: "Thêm phương thức"
      },
      confirmation: {
        title: "Xác nhận rút tiền",
        message: "Bạn có chắc chắn muốn rút {amount} về phương thức thanh toán đã chọn?",
        note: "Thời gian xử lý thường từ 2-5 ngày làm việc tùy thuộc vào phương thức thanh toán.",
        cancel: "Hủy",
        confirm: "Xác nhận rút tiền"
      },
      messages: {
        success: "Yêu cầu rút tiền đã được gửi thành công và đang được xử lý.",
        error: "Đã xảy ra lỗi. Vui lòng thử lại.",
        validation: {
          methodRequired: "Vui lòng chọn phương thức thanh toán",
          invalidAmount: "Vui lòng nhập số tiền hợp lệ",
          insufficientBalance: "Số tiền rút vượt quá số dư hiện có"
        }
      }
    },
    settings: {
      title: "Cài đặt tài khoản",
      tabs: {
        account: "Thông tin tài khoản",
        security: "Bảo mật",
        notification: "Thông báo",
        privacy: "Quyền riêng tư",
        close: "Đóng tài khoản"
      },
      account: {
        title: "Thông tin cá nhân",
        firstName: "Họ",
        lastName: "Tên",
        email: "Email",
        phone: "Số điện thoại",
        address: "Địa chỉ",
        bio: "Giới thiệu",
        save: "Lưu thay đổi"
      },
      security: {
        title: "Bảo mật tài khoản",
        password: {
          title: "Đổi mật khẩu",
          current: "Mật khẩu hiện tại",
          new: "Mật khẩu mới",
          confirm: "Xác nhận mật khẩu mới",
          requirements: "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường và số."
        },
        twoFactor: {
          title: "Xác thực hai yếu tố",
          enable: "Bật xác thực hai yếu tố",
          description: "Khi bật tính năng này, bạn sẽ cần nhập mã xác thực được gửi đến điện thoại mỗi khi đăng nhập."
        },
        sessions: {
          title: "Phiên đăng nhập hiện tại",
          current: "Hiện tại",
          logout: "Đăng xuất",
          save: "Lưu thay đổi"
        }
      },
      notification: {
        title: "Cài đặt thông báo",
        email: {
          title: "Email",
          account: "Cập nhật tài khoản",
          accountDesc: "Nhận thông báo về các thay đổi trên tài khoản của bạn",
          violations: "Vi phạm bản quyền",
          violationsDesc: "Nhận thông báo khi phát hiện vi phạm bản quyền",
          revenue: "Doanh thu và thanh toán",
          revenueDesc: "Nhận thông báo về doanh thu và thanh toán",
          marketing: "Cập nhật tính năng và tin tức",
          marketingDesc: "Nhận thông tin về tính năng mới và tin tức từ Vietrro"
        },
        push: {
          title: "Thông báo đẩy",
          violations: "Vi phạm bản quyền",
          violationsDesc: "Nhận thông báo khi phát hiện vi phạm bản quyền",
          licenses: "Yêu cầu cấp phép mới",
          licensesDesc: "Nhận thông báo khi có yêu cầu cấp phép mới",
          revenue: "Doanh thu và thanh toán",
          revenueDesc: "Nhận thông báo về doanh thu và thanh toán"
        },
        save: "Lưu thay đổi"
      },
      privacy: {
        title: "Cài đặt quyền riêng tư",
        profile: {
          title: "Hiển thị thông tin",
          personal: "Hiện thông tin cá nhân trên hồ sơ công khai",
          personalDesc: "Cho phép hiển thị thông tin cá nhân của bạn trên hồ sơ công khai",
          works: "Hiện danh sách tác phẩm của tôi",
          worksDesc: "Cho phép hiển thị danh sách tác phẩm của bạn trên hồ sơ công khai",
          revenue: "Hiện thông tin doanh thu",
          revenueDesc: "Cho phép hiển thị thông tin doanh thu của bạn"
        },
        catalog: {
          title: "Danh mục tác phẩm",
          visibility: "Hiển thị tác phẩm cho",
          options: {
            all: "Tất cả mọi người",
            registered: "Chỉ người dùng đã đăng ký",
            licensed: "Chỉ người đã mua giấy phép",
            none: "Không ai (Chỉ tôi)"
          },
          licenseInfo: "Hiển thị thông tin giấy phép",
          licenseInfoDesc: "Cho phép hiển thị thông tin giấy phép cho tác phẩm của bạn"
        },
        data: {
          title: "Dữ liệu cá nhân",
          download: "Tải xuống dữ liệu cá nhân",
          downloadDesc: "Tải xuống tất cả dữ liệu cá nhân mà chúng tôi lưu trữ về bạn"
        },
        save: "Lưu thay đổi"
      },
      close: {
        title: "Đóng tài khoản",
        warning: {
          title: "Cảnh báo!",
          description: "Việc đóng tài khoản sẽ:",
          items: [
            "Xóa toàn bộ dữ liệu cá nhân của bạn",
            "Hủy tất cả giấy phép đang hoạt động",
            "Ngừng theo dõi vi phạm bản quyền",
            "Không thể khôi phục lại tài khoản sau khi đóng"
          ],
          note: "Vui lòng cân nhắc kỹ trước khi thực hiện hành động này."
        },
        password: "Nhập mật khẩu để xác nhận",
        reason: {
          label: "Lý do đóng tài khoản",
          placeholder: "Chọn lý do...",
          options: {
            notNeeded: "Tôi không cần dùng nữa",
            technical: "Tôi gặp vấn đề kỹ thuật",
            unsatisfied: "Tôi không hài lòng với dịch vụ",
            newAccount: "Tôi muốn tạo tài khoản mới",
            other: "Lý do khác"
          }
        },
        confirmation: "Tôi hiểu rằng hành động này không thể hoàn tác",
        submit: "Đóng tài khoản"
      },
      messages: {
        success: "Cập nhật thông tin thành công!",
        error: "Đã xảy ra lỗi. Vui lòng thử lại."
      }
    },
    catalog: {
      title: "Khám phá tác phẩm có bản quyền",
      description: "Tìm kiếm và mua giấy phép sử dụng cho các tác phẩm sáng tạo",
      search: {
        title: "Tìm kiếm danh mục",
        placeholder: "Nhập từ khóa tìm kiếm...",
        button: "Tìm kiếm"
      },
      filters: {
        title: "Bộ lọc",
        category: "Danh mục",
        allCategories: "Tất cả danh mục",
        workType: "Loại tác phẩm",
        allTypes: "Tất cả loại",
        licenseType: "Loại giấy phép",
        allLicenses: "Tất cả giấy phép",
        priceRange: "Khoảng giá",
        allPrices: "Tất cả mức giá",
        prices: {
          under1m: "Dưới 1 triệu",
          from1mTo2m: "1 triệu - 2 triệu",
          from2mTo5m: "2 triệu - 5 triệu",
          from5mTo10m: "5 triệu - 10 triệu",
          above10m: "Trên 10 triệu"
        },
        clearFilters: "Xóa bộ lọc"
      },
      display: {
        title: "Hiển thị:",
        grid: "Lưới",
        list: "Danh sách",
        showing: "Hiển thị {count} tác phẩm",
        sort: {
          label: "Sắp xếp:",
          newest: "Mới nhất",
          oldest: "Cũ nhất",
          priceLow: "Giá thấp đến cao",
          priceHigh: "Giá cao đến thấp",
          popularity: "Phổ biến nhất",
          rating: "Đánh giá cao nhất"
        }
      },
      loading: "Đang tải dữ liệu...",
      empty: {
        title: "Không tìm thấy tác phẩm nào phù hợp",
        description: "Vui lòng thử với bộ lọc khác",
        clearFilters: "Xóa bộ lọc"
      },
      buyLicense: "Mua giấy phép",
      viewDetails: "Xem chi tiết",
      licenseInfo: {
        title: "Thông tin",
        standard: {
          title: "Giấy phép Tiêu chuẩn",
          description: "Cho phép sử dụng tác phẩm trong một dự án cụ thể, không độc quyền."
        },
        extended: {
          title: "Giấy phép Mở rộng",
          description: "Cho phép sử dụng tác phẩm trong nhiều dự án, bao gồm cả thương mại."
        },
        exclusive: {
          title: "Giấy phép Độc quyền",
          description: "Cấp quyền sử dụng độc quyền tác phẩm, không ai khác có thể mua giấy phép."
        }
      },
      pagination: {
        previous: "Trước",
        next: "Sau"
      }
    },
    profile: {
      account: {
        title: "Thông tin tài khoản",
        editProfile: "Chỉnh sửa hồ sơ",
        contact: "Liên hệ",
        newWork: "Thêm tác phẩm mới"
      },
      protection: {
        title: "Điểm bảo vệ",
        good: "Tốt",
        average: "Trung bình",
        poor: "Yếu",
        improve: "Cải thiện điểm bảo vệ"
      },
      contact: {
        title: "Thông tin liên hệ",
        email: "Email",
        phone: "Số điện thoại",
        address: "Địa chỉ",
        joinDate: "Ngày tham gia"
      },
      tabs: {
        personal: "Thông tin cá nhân",
        works: "Tác phẩm",
        licenses: "Giấy phép",
        revenue: "Doanh thu"
      },
      personal: {
        intro: "Giới thiệu",
        skills: "Kỹ năng",
        fields: "Lĩnh vực hoạt động"
      },
      works: {
        title: "Tác phẩm của tôi",
        add: "Thêm tác phẩm mới",
        registrationDate: "Ngày đăng ký",
        protection: "Điểm bảo vệ",
        viewAll: "Xem tất cả tác phẩm",
        actions: {
          view: "Xem",
          edit: "Sửa",
          license: "Cấp phép"
        },
        status: {
          registered: "Đã đăng ký",
          processing: "Đang xử lý"
        }
      },
      licenses: {
        title: "Giấy phép",
        manage: "Quản lý giấy phép",
        work: "Tác phẩm",
        expiry: "Ngày hết hạn",
        viewAll: "Xem tất cả giấy phép",
        actions: {
          details: "Chi tiết",
          renew: "Gia hạn"
        },
        status: {
          active: "Đang hoạt động"
        }
      },
      revenue: {
        title: "Doanh thu",
        analytics: "Xem phân tích chi tiết",
        overview: "Tổng quan doanh thu",
        total: "Tổng doanh thu",
        thisMonth: "Tháng này",
        growth: "Tăng trưởng",
        transactions: "Giao dịch gần đây",
        viewAll: "Xem tất cả giao dịch",
        table: {
          id: "ID",
          date: "Ngày",
          description: "Mô tả",
          amount: "Số tiền",
          status: "Trạng thái"
        },
        status: {
          completed: "Hoàn thành",
          processing: "Đang xử lý"
        }
      }
    },
    common: {
      latestAlerts: "Cảnh báo mới nhất",
      days: "{days} ngày",
      loading: "Đang tải...",
      good: "tốt",
      alerts: "cảnh báo",
      issues: "vấn đề",
      noData: "Không có dữ liệu",
      viewAll: "Xem tất cả",
      viewDetails: "Xem chi tiết",
      fileInfo: "Đã chọn {name} ({size} MB)",
      filters: {
        all: "Tất cả"
      },
      statuses: {
        active: "Hoạt động",
        inactive: "Không hoạt động"
      },
      success: "Thành công",
      error: "Lỗi",
      save: "Lưu",
      cancel: "Hủy",
      confirm: "Xác nhận",
      delete: "Xóa",
      edit: "Chỉnh sửa",
      view: "Xem",
      add: "Thêm",
      remove: "Xóa",
      search: "Tìm kiếm",
      filter: "Lọc",
      sort: "Sắp xếp",
      select: "Chọn",
      next: "Tiếp tục",
      back: "Quay lại",
      submit: "Gửi",
      proceed: "Tiếp tục",
      upload: "Tải lên",
      download: "Tải xuống",
      share: "Chia sẻ",
      more: "Xem thêm",
      yes: "Có",
      no: "Không",
      on: "Bật",
      off: "Tắt"
    },
    error: {
      notFound: "Không tìm thấy",
      backToHome: "Về trang chủ",
      goBack: "Quay lại",
      contactSupport: "Liên hệ hỗ trợ",
      contactMessage: "Nếu bạn tin rằng đây là lỗi, vui lòng liên hệ với chúng tôi."
    }
  }
};